import React from "react";
import classNames from "classnames";

import { Checkbox } from "@common/checkbox";
import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function Loader(_: Props) {
  return (
    <ul className={styles.loader}>
      <li className={styles.item}>
        <div className={styles.label}>
          <Checkbox />
          <div className={styles.zone}>
            <Skeleton className={styles.avatar} />
            <Skeleton className={styles.name} />
          </div>
        </div>
      </li>
      <li className={styles.item}>
        <div className={styles.label}>
          <Checkbox />
          <div className={styles.zone}>
            <Skeleton className={styles.avatar} />
            <Skeleton className={styles.name} />
          </div>
        </div>
      </li>
      <li className={styles.item}>
        <div className={styles.label}>
          <Checkbox />
          <div className={styles.zone}>
            <Skeleton className={styles.avatar} />
            <Skeleton className={styles.name} />
          </div>
        </div>
      </li>
    </ul>
  );
}

export { Loader };
